import React, { FC } from 'react';
import clsx from 'clsx';
import { StyledTextArea } from './TextArea.styles';
import { TextAreaProps } from './TextArea.types';
import { Icon } from '@marriott/mi-ui-library';

export const TextArea: FC<TextAreaProps> = ({
  id,
  label,
  placeholder,
  value = '',
  disabled = false,
  isInactive = false,
  hasError = false,
  errorMessage,
  onChange,
}) => {
  return (
    <StyledTextArea data-component-name="m-account-TextArea" data-testid="account-TextArea">
      <div className={clsx('m-input-text-field-v3', hasError && 'is-error', isInactive && 'is-inactive')}>
        <label htmlFor={id}>{label}</label>
        <textarea
          id={id}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={event => onChange?.(event.target.value)}
        />
        {hasError && errorMessage && (
          <div className="message">
            <Icon iconClass={'icon-alert icon-xs pr-1'} />
            <span className="">{errorMessage}</span>
          </div>
        )}
      </div>
    </StyledTextArea>
  );
};
